import React from 'react';

import { Header } from '@components';

const WithdrawalGuideTemplate = () => {
  return (
    <>
      <Header title={'헬스업 탈퇴 가이드'} isBack={false} />
      <div className="sub_container bg-white">
        <div className="Padding-20">
          <h1 className="fs-16 font-black">
            <i class="ri-information-fill dsp-ib"></i> 앱 내 탈퇴 방법
          </h1>
          <div className="fs-14 mt-10 lh-20">
            1. 헬스업 앱 로그인 후 내정보 메뉴 선택 <br />
            2. '내 정보 변경' 선택
            <br />
            3. '회원탈퇴' 선택
            <br />
            4. 유의사항 확인 및 동의 후 '회원탈퇴' 선택
          </div>

          <div className="mt-20">
            <img src="/assets/images/img_screenshot_01.png" className="Width-100" />
          </div>

          <h2 className="fs-16 font-black mt-20">
            <i class="ri-message-3-line dsp-ib"></i> 앱 미설치시 탈퇴 방법
          </h2>
          <div className="fs-14 mt-10 lh-20">
            헬스업 고객센터: help@openit.co.kr
            <br />
            이메일로 회원탈퇴 요청 접수
          </div>

          <h2 className="fs-16 font-black mt-20">
            <i class="ri-message-3-line dsp-ib"></i> 안내사항
          </h2>
          <div className="fs-14 mt-10 lh-20">
            회원탈퇴 후 개인정보는 모두 즉시 삭제 됩니다.
            <br />
            삭제되는 정보: 회원정보, 건강측정정보, 건강검진정보, 걸음수
          </div>
        </div>
      </div>
    </>
  );
};

export default WithdrawalGuideTemplate;
